import {LineItem, OptionSelected, Order} from "../bo/order";
import {destinationToGoogleMapDirectionsUrl} from "../google/directions";
import {AusDollar} from "./types";
import {sizeRe} from "../shop/product";


// returns address object or falsy.
export function isDelivery(order: Order) {
    // @ts-ignore
    const address = order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address;
    return (address && (address.addressLine1 || address.addressLine2)) ? address : undefined;
}

export function isDeliveryToBusiness(order: Order) {
    // @ts-ignore
    const address = order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address;
    return address && address.business;
}

export function addressToString(address: any) : string {
    if (! address) {
        return "";
    }
    const keys =  [ "addressLine1", "addressLine2", "city", "zipCode", "country" ];
    const bits : string[] = [];
    for (const key of keys) {
        if (address[key] !== undefined && address[key].length > 0) {
            bits.push(address[key]);
        }
    }
    return bits.join(", ");
}

export function addressToStringForGoogle(address: any) : string {
    if (! address) {
        return "";
    }
    const keys =  [ "addressLine1", "city", "zipCode", "country" ];
    const bits : string[] = [];
    for (const key of keys) {
        if (address[key] !== undefined && address[key].length > 0) {
            bits.push(address[key]);
        }
    }
    return bits.join(", ");
}

export function getDeliveryCost(order: Order) : AusDollar | undefined {
    if (! isDelivery(order)) {
        return undefined;
    }
    let deliveryCost : AusDollar  = 0;
    // @ts-ignore
    const total = +(order.totals?.total);
    let subtotal = 0;
    // @ts-ignore
    for (const lineItem of order.lineItems) {
        // @ts-ignore
        subtotal += +(lineItem.totalPrice);
    }
    deliveryCost = total - subtotal;
    return deliveryCost;
}

export function getOrderTimeInfo(order: Order) : string | undefined {
    const out : string[] = []
    if (! isDelivery(order)) {
        for (const lineItem of (order.lineItems ||[])) {
            // @ts-ignore
            for (const customField of (lineItem.customTextFields || [])) {
                if (customField.title && customField.title.toLowerCase().indexOf("delivery date") >= 0 && customField.value) {
                    const match = customField.value.match(/(At (.*))/);
                    if (match) {
                        out.push("Pick up at " + match[2]);
                    }
                }
            }
        }
    }
    return out.length > 0 ? out.join("\n") : undefined;
}

export function getDirectionsUrl(order: Order | undefined) {
    const address = order && isDelivery(order);
    const destination = addressToStringForGoogle(address);
    return address && address.geocoded && destinationToGoogleMapDirectionsUrl(destination);
}

export function isToPay(order: Order | undefined) {
    const history = (order && order.orderHistory) || [];
    const toPayIdx = history.findIndex(h => h.newStatus == "To pay");
    const paidIdx = history.findIndex(h => h.newStatus == "Paid");
    const toPay = toPayIdx >= 0 && paidIdx < toPayIdx;
    return toPay;
}

export function isCancelled(order: Order) {
    const history = (order && order.orderHistory) || [];
    const cancelledIdx = history.findIndex(h => h.newStatus == "Cancelled");
    return cancelledIdx >= 0;
}

const extraLabels : any = {
    "Chocolate": {
        "!No": 1,
    },
    "Wine": {
        "!No": 1,
    },
    "Self care": {
        "!No": 1,
    },
    "Soft toys": {
        "!No": 1,
    },
    "Add chocolate" : {
        "Yes" : 1,
        "Lindt chocolate 235g": 1,
    },
    "Add wine" : {
        "!No" : 1
    },
    "Canberra Local Produce": {
        "!No" : 1
    }
};

export function labelsRequired(option: OptionSelected) : number {

    let cnt = 0;

    const selection = option.selection || "";
    const name = option.option || "";
    for (const key in extraLabels) {
        if (name.indexOf(key) === 0) {
            for (const val in extraLabels[key]) {
                if (selection.indexOf(val) === 0) {
                    cnt += extraLabels[key][val];
                }
                if (val.indexOf("!") === 0 && selection.indexOf(val.substring(1)) !== 0) {
                    cnt += extraLabels[key][val];
                }
            }
        }
    }

    return cnt;
}

export function highlightOption(option: OptionSelected) : boolean {

    const selection = option.selection || "";
    const name = option.option || "";
    if (name.match(sizeRe)) {
        return false;
    }

    if (selection.toLowerCase() == "no") {
        return false;
    }

    return true;
}

export type LineItemExtras = {
    cnt: number;
    vase: boolean;
    box: boolean;
}

export function calcLineItemExtras(lineItem: LineItem) : LineItemExtras {
    let cnt = 1;
    let box = false;
    let vase = false;
    const options = lineItem.options || [];
    for (const option of options) {
        cnt += labelsRequired(option);

        const selection = option.selection || "";
        const name = option.option || "";

        if (selection.toLowerCase().indexOf("in gift box") >= 0) {
            box = true;
        }
        if (name.toLowerCase().indexOf("vase") >= 0) {
            vase = true;
        }
    }

    return {
        cnt: cnt,
        vase: vase,
        box: box
    }

}

export function countLabels(lineItem: LineItem) : number {
    const e = calcLineItemExtras(lineItem);
    const quantity = lineItem.quantity || 1;
    let cnt = e.cnt;
    if (e.box && e.vase) {
        cnt = cnt + 1;
    }
    return quantity * cnt;
}


export function hasExtras(order?: Order) : boolean {
    for (const line of order?.lineItems || []) {
        if (countLabels(line) > 1) {
            return true;
        }
    }
    return false;
}


